var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isScrollButtonVisible ? _c('div', {
    class: ['scroll-button', _vm.isPC ? 'scroll-button-pc' : ''],
    on: {
      "click": _vm.scrollToMessageListBottom
    }
  }, [_c('Icon', {
    attrs: {
      "width": "15px",
      "height": "15px",
      "file": _vm.isPC ? _vm.arrowDownIconWhite : _vm.arrowDownIcon
    }
  }), _vm.scrollButtonContent ? _c('div', {
    class: _vm.isPC ? 'scroll-button-text-pc' : 'scroll-button-text'
  }, [_vm._v(" " + _vm._s(_vm.scrollButtonContent) + " ")]) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }